import styled from '@emotion/styled';
import {
  SelectionsGroup as SelectionsGroupWrapper
} from 'src/domains/sportsbook/webview/components/selectionsGroupUnified/SelectionGroupUnified.style';
import { withConfig } from 'src/withConfig';

/* 1 - You can delete this if z-index will be deleted in Selection component */
export const MoreLessGroup = withConfig(theme => styled('div', { label: 'MoreLessGroup' })`
    background-color: ${theme.star.moreLessButton.bgColor};
    text-align: center;
    position: relative; /* 1 */
    border-top: solid 1px ${theme.star.unified.eventRow.borderColor};
    margin-top: -1px; /* 1 */
`);

export const SelectionsGroup = withConfig(theme => styled(SelectionsGroupWrapper, { label: 'SelectionsGroup' })`
    flex-wrap: nowrap;
    gap: 0;

    & [class$='SelectionsGroupLiItem'] {
        flex-flow: row;
        padding: 8px;
        border-radius: 0;
        border-bottom: 1px solid ${theme.star.unified.eventRow.borderColor};
        gap: ${theme.star.gap.small};
    }

    & [class$='SelectionsGroupName'] {
        display: flex;
        padding: 0 4px;
        justify-content: flex-start;
        background: none;
        min-height: 44px;
        border: none;
        min-width: 0;
        flex: 1 1 auto;
        width: 0;

        & > span {
            /* stylelint-disable-next-line value-no-vendor-prefix */
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            min-width: 0;
            width: 100%;
            white-space: normal;
        }
    }
`);

export const SelectionList = withConfig(theme => styled('ul', { label: 'SelectionList' })`
    display: flex;
    flex-flow: column nowrap;
    flex: 1 1 auto;
    width: 100%;
    border-right: 1px solid ${theme.star.unified.selection.borderColor};
    align-self: flex-start;
`);